import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserDataService {
    private dataSource = new Subject();
    public userData = this.dataSource.asObservable();

    constructor() {
    }

    updateUserData(value: any) {
        this.dataSource.next(value);
    }

}